<template>
  <div>
    <div class="d-flex">
      <div class="flex-grow-1">
        <Banner class="ml-5 mb-0" />
      </div>
      <div class="mt-3 ml-2 mr-2">
        <TutorialButton :tutorialName="$options.name" />
      </div>
    </div>
    <div class="d-flex mt-2 ml-7">
      <v-icon color="purple">{{ icon.user }}</v-icon>
      <div class="ml-3 font-weight-regular">
        {{ userData.UserName }}
      </div>
    </div>
    <ServiceDashboardWidget />
    <TaskDashboardWidget />
    <Weather />
    <v-footer>
      <span class="caption">Copyright © 2024 ArrowStorm Corporation</span>
    </v-footer>
  </div>
</template>

<script>
import icon from '@/constants/Icons'
import { userData } from '@/store/UserSession'
import Weather from '@/components/dashboard/Weather'
import ServiceDashboardWidget from '@/components/ScheduledService/ServiceDashboardWidget'
import TaskDashboardWidget from '@/components/ScheduledTask/TaskDashboardWidget'
import Banner from '@/components/dashboard/Banner'
import TutorialButton from '@/components/controls/TutorialButton'
export default {
  name: 'DashboardPage',
  components: {
    Banner,
    ServiceDashboardWidget,
    TaskDashboardWidget,
    TutorialButton,
    Weather
  },
  setup() {
    return { icon, userData }
  }
}
</script>

<style lang="scss" scoped></style>
